import React from 'react';
import { runLoading } from '../../../utils/showLoadingScreen';
import ConditionalWorkflowTemplate from '../../ConditionalWorkflow/ConditionalWorkflowTemplate';
import FormBuilderPage from '../../FormBuilder/FormBuilderPage';
import SequentialForm from '../../SequentialForm/SequentialForm';
import TriggerFromZapierTemplate from '../../TriggerFromZapier/TriggerFromZapierTemplate';
import ApiResReqTemplate from '../../APIRequestAndResponse/APIResReqTemplate';
import WebhookImportTemplate from '../../WebhookImport/WebhookImportTemplate';
import TriggerAZapTemplate from '../../TriggerAZap/TriggerAZapTemplate';
import TimeDelayTemplate from '../../TimeDelay/TimeDelayTemplate';
import SlackTemplate from '../../Slack/SlackTemplate';
import CreateDatabaseRecordTemplate from '../../CreateDatabaseRecord/CreateDatabaseRecordTemplate';
import UpdateDatabaseRecordTemplate from '../../UpdateDatabaseRecord/UpdateDatabaseRecordTemplate';
import TriggerAnotherWorkflowTemplate from '../../TriggerAnotherWorkflow/TriggerAnotherWorkflowTemplate';
import MergeWorkflowTemplate from '../../MergeWorkflow/MergeWorkflowTemplate';
import ConditionalLogicTemplate from '../../ConditionalLogic/ConditionalLogicTemplate';
import ScheduleStartTemplate from '../../ScheduleStart/ScheduleStartTemplate';
import TriggerFromAWorkflowTemplate from '../../TriggerFromAWorkflow/TriggerFromAWorkflowTemplate';
import EmailWriter from '../../Email/EmailWriter';
import TransformTemplate from '../../ListTransform/TransformTemplate';
import ParseJsonTemplate from '../../ParseJSON/ParseJSONTemplate';
import LoopThroughListTemplate from '../../LoopThroughList/LoopThroughListTemplate';
import ApiExportTemplate from '../../ApiExport/ApiExportTemplate';
import CodeTemplate from '../../Code/CodeTemplate';
import CalculatorTemplate from '../../Calculator/CalculatorTemplate';
import QueryDatabaseTemplate from '../../QueryDatabase/QueryDatabaseTemplate';
import DocumentTemplate from '../../DocumentEditor/DocumentTemplate';
import BulkAssessmentTemplate from '../../BulkAssessment/BulkAssessmentTemplate';
import SessionVariablesTemplate from '../../SessionVariable/SessionVariablesTemplate';
import EmailTriggerTemplate from '../../EmailTrigger/EmailTriggerTemplate';
import AIAssistantTemplate from '../../AIAssistant/AIAssistantTemplate';
import ConditionalWorkflowPathTemplate from '../../ConditionalWorkflowPath/ConditionalWorkflowPathTemplate';
import BranchPathsTemplate from '../../BranchPaths/BranchPathsTemplate';
import TriggerFromExternalTemplate from '../../TriggerFromExternal/TriggerFromExternalTemplate';
import TriggerOnDatabaseUpdateTemplate from '../../TriggerOnDatabaseUpdate/TriggerOnDatabaseUpdateTemplate';
import TriggerFromApiPollingTemplate from '../../TriggerFromApiPolling/TriggerFromApiPollingTemplate';
import AwaitExternalEventTemplate from '../../AwaitExternalEvent/AwaitExternalEventTemplate';
import ConvergeThreadsTemplate from '../../ConvergeThreads/ConvergeThreadsTemplate';
import AIAgentTemplate from '../../AIAgent/AIAgentTemplate';
import DynamicFormBuilderTemplate from '../../DynamicFormBuilder/DynamicFormBuilderTemplate';
import DynamicReviewTaskTemplate from '../../DynamicReviewTask/DynamicReviewTaskTemplate';
//this function detects the type of component by type
//and returns the template for the componentPane to render

//when adding a new component to be rendered in the pane you will have to add the template into here
export default function getTemplate(type) {
  switch (type) {
    case 'conditional_workflow':
      return <ConditionalWorkflowTemplate />;
    case 'email':
      return <EmailWriter />;
    case 'merge_workflow':
      return <MergeWorkflowTemplate />;
    case 'conditional_logic':
      return <ConditionalLogicTemplate />;
    case 'schedule_start':
      return <ScheduleStartTemplate />;
    case 'trigger_from_a_workflow':
      return <TriggerFromAWorkflowTemplate />;
    case 'api_export':
      return <ApiExportTemplate />;
    case 'api_request_and_response':
      return <ApiResReqTemplate />;
    case 'calculator':
      return <CalculatorTemplate />;
    case 'code':
      return <CodeTemplate />;
    case 'advanced_code':
      return <CodeTemplate />;
    case 'create_database_record':
      return <CreateDatabaseRecordTemplate />;
    case 'document_editor':
      return <DocumentTemplate />;
    case 'form':
      return <FormBuilderPage />;
    case 'sequential_form':
      return <SequentialForm isFormSection={false} />;
    case 'form_section':
      return <SequentialForm isFormSection={true} />;
    case 'list_transform':
      return <TransformTemplate />;
    case 'loop_through_list':
      return <LoopThroughListTemplate />;
    case 'parse_json':
      return <ParseJsonTemplate />;
    case 'branch_paths':
      return <BranchPathsTemplate />;
    case 'data_bank':
    case 'query_database_record':
      return <QueryDatabaseTemplate />;
    case 'workflow_data':
    case 'slack':
      return <SlackTemplate />;
    case 'time_delay':
      return <TimeDelayTemplate />;
    case 'trigger_a_zap':
      return <TriggerAZapTemplate />;
    case 'trigger_from_zapier':
      return <TriggerFromZapierTemplate />;
    case 'trigger_another_workflow':
      return <TriggerAnotherWorkflowTemplate />;
    case 'trigger_from_external_app':
      return <TriggerFromExternalTemplate />;
    case 'update_database_record':
      return <UpdateDatabaseRecordTemplate />;
    case 'bulk_assessment':
      return <BulkAssessmentTemplate />;
    case 'webhook':
      return <WebhookImportTemplate />;
    case 'session_variables':
      return <SessionVariablesTemplate />;
    case 'trigger_via_email':
      return <EmailTriggerTemplate />;
    case 'ai_assistant':
      return <AIAssistantTemplate />;
    case 'conditional_workflow_path':
      return <ConditionalWorkflowPathTemplate />;
    case 'trigger_on_database_update':
      return <TriggerOnDatabaseUpdateTemplate />;
    case 'trigger_from_api_polling':
      return <TriggerFromApiPollingTemplate />;
    case 'await_external_event':
      return <AwaitExternalEventTemplate />;
    case 'converge_threads':
      return <ConvergeThreadsTemplate />;
    case 'ai_agent':
      return <AIAgentTemplate />;
    case 'dynamic_form':
      return <DynamicFormBuilderTemplate />;
    case 'dynamic_review_task':
      return <DynamicReviewTaskTemplate />;
    default:
      return runLoading();
  }
}
